<template>
  <div class="mptitle_and_context">
    <h2 class="title" v-if="title !== ''">{{ title }}</h2>
    <h4 class="subTitle" v-if="subTitle !== ''">{{ subTitle }}</h4>
    <div class="context" v-if="context !== ''" v-html="context"></div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    context: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="less" scoped>
.mptitle_and_context {
  padding: 10px 5px;
  .title {
    padding: 10px 0;
    color: #17233d;
  }
  .subTitle {
    padding: 3px 0;
    color: #17233d;
  }
  .context {
    color: #515a6e;
    padding-bottom: 5px;
  }
}
</style>
